export default __webpack_public_path__ + "static/media/plexusstrike1.e16fe7c9.png";